<script setup>
import { onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
});

const route = useRoute();

const setTitle = (title) => {
  document.title = title;
};

onMounted(() => {
  setTitle(props.title);
});

watch(() => route.fullPath, () => {
  setTitle(props.title);
});
</script>

<template>
  <!-- Este componente no renderiza nada visualmente -->
</template>
